export const SIMILAR_PACKAGES_SEARCH_DELAY = 2 * 1000;

export const SIMILAR_PACKAGES_GO_TO_HOTEL = 'SIMILAR_PACKAGES_GO_TO_HOTEL';

export const SIMILAR_PACKAGES_STATE = {
  INITIAL: 'initial',
  PREPARE: 'prepare',
  PERFORMING: 'performing',
  EQUIVALENT: 'equivalent',
  ALTERNATIVE: 'alternative',
  NO_RESULTS: 'no_results',
  REDIRECT: 'redirect',
};

export const SIMILAR_PACKAGES_CLICK_ON_ALTERNATIVE = 'alternative';

// SEARCHER
export const START_SEARCH = 'START_SEARCH';

// список полей, которые нужно обновить при актуализации
export const SIMILAR_PACKAGES_GET_PACKAGE_PARAMS = [
  'dates_info', // contains: start_date, end_date, check_in, check_out, original_nights, nights_count
  'kids_count',
  'kids_ages',
  'adults_count',
  'pansion',
  'pansion_original',
  'pansion_description',
  'operator',
  'booking_url',
  'id', // package_id
];
